import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {MotoristaMonitoramentoModel} from "../content/pages/components/torre-de-controle/monitoramento-entregas/info-motorista/models/motorista-monitoramento.model";
import {InfoMapaMonitoramentoEntregasModel} from "../content/pages/components/torre-de-controle/monitoramento-entregas/info-motorista/models/info-mapa-monitoramento-entregas.model";
import {FiltroDetalhesMotoristaMonitoramentoModel} from "../content/pages/components/torre-de-controle/monitoramento-entregas/models/filtro-detalhes-motorista-monitoramento.model";

@Injectable({providedIn: 'root'})
export class MotoristasService extends GenericServicesMotoristaService {


	constructor(
		private _mensagensService: MensagensService,
		private _httpClient: HttpClient
	) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/motoristas';
	}

	buscarInformacoesMotoristas(filtro: {idsMotoristas: string[], idsFiliais: string[], idsVeiculos: string[]}): any {
		return this.post<any[]>('/informacoesMotoristas', {
			dados: filtro , exibirLoading: true});
	}


	displayAutoComplete = (value) => {
		return value ? `${value.id} - ${value.nome}` : '';
	};

	pesquisarAutoComplete(valor) {
		if (valor === undefined || valor === null) {
			return of([]);
		}
		return this.get<any[]>('/pesquisarLimitado', {
			dados: {
				value: valor
			},
			exibirLoading: false
		});
	}

	pesquisarLimitadoMotorista(value) {
		if (value === undefined || value === null) {
			return of([]);
		}
		return this.get<any[]>('/pesquisarLimitadoMotorista', {
			dados: {
				nome: value
			},
			exibirLoading: false
		});
	}

	pesquisarLimitadoNomeId(value) {
		if (value === undefined || value === null) {
			return of([]);
		}
		return this.get<any[]>('/pesquisarLimitado', {
			dados: {
				value: value
			},
			exibirLoading: false
		});
	}

	listarMotoristasComUsuario() {
		return this.get<any[]>('/listarComUsuario');
	}

	listarMotoristasVinculadosAoUsuario(id, exibirLoading = true) {
		return this.get<any>('/listarVinculadosAoUsuario', {
			dados: {id},
			exibirLoading
		});
	}

	listarMotoristas() {
		return this.get<any[]>('/listar');
	}

	listarMotoristasComUsuarioOtimizado() {
		return this.get<any[]>('/listarComUsuarioOtimizado');
	}

	listarComCarregamento(id) {
		return this.get<any[]>('/listarComCarregamento', {
			dados: {id}
		});
	}

	listarMotoristasComNotificacoes() {
		return this.get<any[]>('/notificacoesMotorista');
	}

	listarAtivosPorFilialUsuarioLogado(id, exibirLoading = true) {
		return this.get<any>('/listarAtivosPorFilial', {
			dados: {id},
			exibirLoading
		});
	}

	buscarDadosMotoristaMonitoramento(idMotorista, dataRastro, isRastreador, exibirLoading = true): Observable<MotoristaMonitoramentoModel[]> {
		return this.get<any>('/buscarDadosMotoristaMonitoramento', {
			dados: {idMotorista, dataRastro, isRastreador},
			exibirLoading
		});
	}

	buscarRastroMonitoramento(idMotorista, idRomaneio, dataRastro, exibirLoading = true): Observable<InfoMapaMonitoramentoEntregasModel> {
		return this.get<any>('/buscarRastroMonitoramento', {
			dados: {idMotorista, dataRastro, idRomaneio},
			exibirLoading
		});
	}

	buscarDetalhesMotoristasMonitoramento(filtros: FiltroDetalhesMotoristaMonitoramentoModel[], exibirLoading = true): Observable<MotoristaMonitoramentoModel[]> {
		return this.post<any>('/buscarDetalhesMotoristasMonitoramento', {
			dados: filtros,
			exibirLoading
		});
	}

	listarAtivosValidacaoFilial(usuario, exibirLoading = true) {
		return this.get<any>(`/listarAtivosValidacaoFilial/${usuario}`);
	}

	listarAtivosValidacaoFilialComDespesas(usuario, exibirLoading = true) {
		return this.get<any>(`/listarAtivosValidacaoFilialComDespesas/${usuario}`);
	}


	listarMotoristasTorreControle() {
		return this.get<any>(`/listarMotoristasTorreControle`);
	}

	listarSemUsuario(idMotorista) {
		return this.get<any[]>(`/listarSemUsuario/${idMotorista}`);
	}

	listarMotoristaUsuarioValidacaoFilial(usuario, exibirLoading = true) {
		return this.get<any>(`/listarMotoristaUsuarioValidacaoFilial/${usuario}`);
	}

	listarMotoristasAndResponsaveisUsuario() {
		return this.get<any>(`/listarMotoristasAndResponsaveisUsuario`);
	}

	listarMotoristasFiliaisSemUsuario() {
		return this.get<any>(`/listarMotoristasFiliaisSemUsuario`);
	}


	listarSimplificadoFiliais(usuario) {
		return this.get<any>(`/listarSimplificadoFiliais/${usuario}`);
	}
}
